
// This is only replacement for the real SzumDrawer class from Telematics

export class SzumDrawer {

    constructor() {
        this.map = null;
    }

    assignMap(map) {
        if (map === null) {
            throw new Error('Map cannot be null');
        }
        if (typeof map === 'undefined') {
            throw new Error('Map cannot be undefined');
        }
        if (typeof map !== 'object') {
            throw new Error('Map must be an object');
        }
        this.map = map;
    }

    getMap() {
        return this.map;
    }

}